<template>
  <div class="sidebar-wrapper">
    <!-- Header with logo -->
    <div class="sidebar-header">
      <img src="@/assets/logo_selidaire.png" alt="selidaire" width="75" class="sidebar-logo">
    </div>

    <v-divider ></v-divider>

    <v-list density="compact" nav class="sidebar-nav">

      <v-list-item
        :to="{ name: 'Home' }"
        prepend-icon="mdi-home"
        title="Accueil"
        rounded="lg"
        active-color="white"
      ></v-list-item>

      <v-list-subheader class="sidebar-subheader">L'ASSOCIATION</v-list-subheader>

      <v-list-group value="qui-sommes-nous">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-information-outline"
            title="Qui sommes nous?"
            rounded="lg"
          ></v-list-item>
        </template>
        <v-list-item :to="{ name: 'MotPresident' }" prepend-icon="mdi-account-tie" title="Mot du Président" rounded="lg" active-color="white" style="white-space: nowrap"></v-list-item>
        <v-list-item :to="{ name: 'Status' }" prepend-icon="mdi-file-document-outline" title="Statuts" rounded="lg" active-color="white"></v-list-item>
        <v-list-item :to="{ name: 'Organigramme' }" prepend-icon="mdi-sitemap-outline" title="Organigramme" rounded="lg" active-color="white"></v-list-item>
        <v-list-item :to="{ name: 'Adhesion' }" prepend-icon="mdi-account-plus-outline" title="Adhérer" rounded="lg" active-color="white"></v-list-item>
      </v-list-group>

      <v-list-subheader class="sidebar-subheader">ACTUALITÉS</v-list-subheader>

      <v-list-item :to="{ name: 'News' }" prepend-icon="mdi-newspaper-variant-outline" title="Actualité" rounded="lg" active-color="white"></v-list-item>
      <v-list-item :to="{ name: 'Meetings' }" prepend-icon="mdi-calendar-star" title="Evènements" rounded="lg" active-color="white"></v-list-item>
      <v-list-item :to="{ name: 'Publications' }" prepend-icon="mdi-book-open-page-variant-outline" title="Publications" rounded="lg" active-color="white"></v-list-item>
      <v-list-item :to="{ name: 'Presse' }" prepend-icon="mdi-newspaper-variant" title="Presse" rounded="lg" active-color="white"></v-list-item>

      <v-list-subheader class="sidebar-subheader">ESPACE</v-list-subheader>

      <v-list-item :to="{ name: 'Members' }" prepend-icon="mdi-account-group-outline" title="Membres" rounded="lg" active-color="white"></v-list-item>
      <v-list-item :to="{ name: 'WhiteBook' }" prepend-icon="mdi-book-variant" title="Livre Blanc" rounded="lg" active-color="white"></v-list-item>

      <v-divider  class="my-2"></v-divider>

      <v-list-item :to="{ name: 'AddNewsletter' }" prepend-icon="mdi-email-newsletter" title="Newsletter" rounded="lg" active-color="white"></v-list-item>
      <v-list-item :to="{ name: 'Contact' }" prepend-icon="mdi-email-outline" title="Contact" rounded="lg" active-color="white"></v-list-item>

    </v-list>
  </div>
</template>

<style scoped>
.sidebar-wrapper {
  height: 100%;
  background: #ffffff;
}

.sidebar-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 12px 12px;
  background: #ffffff;
}

.sidebar-logo {
  border-radius: 8px;
  margin-bottom: 10px;
}

.sidebar-title {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: #E65100;
  margin-bottom: 2px;
}

.sidebar-subtitle {
  font-size: 0.6rem;
  letter-spacing: 0.1em;
  color: #9e9e9e;
  text-transform: uppercase;
}

.sidebar-nav {
  padding: 4px 2px;
}

.sidebar-nav :deep(.v-list-item) {
  padding-inline-start: 8px !important;
  min-height: 32px !important;
}

.sidebar-nav :deep(.v-list-item__prepend) {
  width: 28px !important;
}

.sidebar-nav :deep(.v-list-item__prepend .v-icon) {
  font-size: 16px !important;
}

.sidebar-nav :deep(.v-list-group__items .v-list-item) {
  padding-inline-start: 16px !important;
}

.sidebar-subheader {
  font-size: 0.55rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.12em !important;
  color: #9e9e9e !important;
  margin-top: 4px;
  padding-left: 12px !important;
}

.sidebar-nav :deep(.v-list-item-title) {
  color: #212121;
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-nav :deep(.v-list-item__prepend .v-icon) {
  color: #E65100;
}

/* Active item */
.sidebar-nav :deep(.v-list-item--active) {
  background: #e3f2fd !important;
  border-left: 3px solid #E65100;
}

.sidebar-nav :deep(.v-list-item--active .v-list-item-title) {
  color: #E65100;
  font-weight: 600;
}

.sidebar-nav :deep(.v-list-item--active .v-icon) {
  color: #E65100;
}

/* Hover */
.sidebar-nav :deep(.v-list-item:hover:not(.v-list-item--active)) {
  background: #f5f5f5 !important;
}

.sidebar-nav :deep(.v-list-group__items .v-list-item-title) {
  font-size: 0.72rem;
}
</style>
